// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"_21TuB0Dn6JJ4uEYkpf9Fnt","Open":"_1pVYRaiLBtOhv7pDNimBtN","Close":"_3Yv1lLM58kyRaR73W22KWZ","Logo":"_3TkPvMPv1WUzP1NgAUT6zE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/SideDrawer.css
// module id = 117
// module chunks = 0